const React = require('react');
const Link = require('react-router-dom').Link;
const SharedConstants = require('../../../../shared/sharedConstants');

import PortfolioCard from './portfolioCard.js';
import {
   IconButton,
   Tooltip,
   Grid,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function EditButton(props){
   let tooltipTitle = (title) => {
      return (
         <React.Fragment>
            <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
               {title}
            </div>
         </React.Fragment>
      )
   };

   return(
      <Tooltip title={tooltipTitle("Edit")}>
         <a className={'btn-incubator-edit float-right'} href={'/sponsor/editIncubator?id=' + props.id}>
            <IconButton aria-label="Edit Incubator">
               <FontAwesomeIcon icon={['far',"edit"]} />
            </IconButton>
         </a>
      </Tooltip>
   )
}

export class PortfolioList extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      const { setPortfolioToDelete, hideWhenEmpty, portfolioList } = this.props;

      if(hideWhenEmpty && portfolioList.length === 0) return <div />;

      let portfolios = portfolioList.map((portfolio) => {
         let nextDeadline = null;
         let dates = [
            {text: 'Start Date', date: portfolio.beginTime},
            {text: 'Display Date', date: portfolio.displayTime},
            {text: 'End of Suggestion Period', date: portfolio.suggestionEndTime},
            {text: 'Live Forum', date: portfolio.askMeAnythingTime},
            {text: 'Abstract Due Date', date: portfolio.abstractDueTime},
            {text: 'Extended Abstract Due Date', date: portfolio.extendedAbstractDueTime},
            {text: 'Proposal Due Date', date: portfolio.proposalDueTime},
            {text: 'Incubator End Date', date: portfolio.incubatorEndTime},
            {text: 'Projected Award Date', date: portfolio.awardTime},
            {text: 'Overview Finalized Date', date: portfolio.descriptionFinalizedTime},
         ];

         let setNextDeadline = (date) => {
            if(!nextDeadline || new Date(date.date) < new Date(nextDeadline.date))
               nextDeadline = {text: date.text, date: date.date};
         };

         for (let date of dates) {
            if (new Date(date.date) > new Date()) {
               setNextDeadline(date);
            }
         }

         let linkTo = '/portfolio?idPortfolio=' + portfolio.id;
         if(portfolio.privacyType === SharedConstants.PortfolioType.Sponsored
            || portfolio.privacyType === SharedConstants.PortfolioType.SponsoredPrivate
            || portfolio.privacyType === SharedConstants.PortfolioType.SponsoredSemiPrivate){

            linkTo = '/incubator?idIncubator=' + portfolio.id;
         }

         return (
            <Grid item md={6} key={portfolio.id}>
               <PortfolioCard 
                  linkTo={linkTo} 
                  portfolio={portfolio}
                  setPortfolioToDelete={setPortfolioToDelete}
               />
            </Grid>
         );
      });

      return (
         <Grid container alignItems="stretch" spacing={2}>
            {portfolios}
         </Grid>
      );
   }
};